import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Icon from '../UI/Icon';
import sprechheldenHeld from '../../assets/sprechheldenHeld.png';
import './ModuleIntroModal.css';

function ModuleIntroModal({ show, onClose }) {
  const programSteps = [
    {
      id: 1,
      title: 'Orientierung und Auswahl der Übungslaute',
      description: 'Falls Sie nicht wissen welche Laute bei Ihrem Kind betroffen sind, können Sie sich am Screening-Ergebnis orientieren oder in der Meilensteintabelle unter "Sprachentwicklung verstehen" nachschauen. Bei Unsicherheiten können Sie einen persönlichen Beratungstermin buchen.',
      iconName: 'compass',
      color: '#B2D8D8'
    },
    {
      id: 2,
      title: 'Durchlesen der Anweisungen',
      description: 'Wichtig ist, dass Sie die Reihenfolge der Module beachten und einhalten. Lesen Sie sich unbedingt vorher die Instruktionen zu den jeweiligen Modulen durch.',
      iconName: 'book-open',
      color: '#FFB7B2'
    },
    {
      id: 3,
      title: 'Beginn mit den Modulen',
      description: 'Achten Sie darauf, dass Sie die dazugehörigen Videobeispiele mitanschauen. Die Videos unterstützen Sie bei der korrekten Durchführung der Übungen.',
      iconName: 'play-circle',
      color: '#FFF3CD'
    }
  ];

  return (
    <Modal 
      show={show} 
      onHide={onClose}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      className="module-intro-modal"
    >
      <Modal.Header>
        <Modal.Title className="text-center w-100">
          <div className="modal-hero-header">
            <img src={sprechheldenHeld} alt="Sprechheld" className="modal-hero-image" />
            <h3>Aufbau unseres Programms</h3>
          </div>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="py-4">
        <div>
          <div className="text-center mb-4">
            <p className="lead text-secondary">
              Mit dieser Übersicht möchten wir Ihnen den gesamten Ablauf unseres Programms verständlich darstellen, damit Sie schon vor dem Start genau wissen, was auf Sie zukommt und worauf Sie achten können.
            </p>
          </div>

          <div className="steps-timeline">
            {programSteps.map((step, index) => (
              <div key={step.id} className="step-timeline-item">
                <div className="step-timeline-content">
                  <div className="step-header">
                    <span 
                      className="step-badge"
                      style={{ 
                        backgroundColor: step.color,
                        color: '#333'
                      }}
                    >
                      Schritt {index + 1}
                    </span>
                  </div>
                  
                  <div className="step-body">
                    <h4 className="step-title">{step.title}</h4>
                    <p className="step-description">{step.description}</p>
                  </div>
                </div>
                
              </div>
            ))}
          </div>

          <div className="text-center mt-4 pt-3 border-top">
            <p className="text-muted small mb-3">
              <Icon name="info-circle" className="me-2" />
              Nach dieser Orientierung können Sie mit Modul 1 beginnen. Die Module bauen aufeinander auf und führen Sie Schritt für Schritt zum Erfolg.
            </p>
          </div>
        </div>
      </Modal.Body>
      
      <Modal.Footer className="justify-content-center">
        <Button 
          variant="primary" 
          size="lg" 
          onClick={onClose}
          className="px-4"
        >
          Los geht's!
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModuleIntroModal;